export const WorkordersConfigurationErrors: Record<string, string> = {
  'ultracar.errors.there_are_pending_deliveries':
    'É necessário fazer todas as entregas de materiais pendentes antes de mudar para baixa de estoque automática.',
};
